const rateContainers = document.querySelectorAll(".rate-container");

rateContainers.forEach(container => {
    const sidebarUL = container.querySelector('.sidebar .rate-links')
    const rates = container.querySelectorAll('.accordion-container');

    // rates.forEach(rateBlock => {
    //     const newEl = document.createElement('li');
    //     const title = rateBlock.id;
    //     newEl.innerHTML = '<a href="#' + title + '">' + title.replace(/_/g, " ") + '</a>';
    //     sidebarUL.appendChild(newEl);
    // })

    document.addEventListener('DOMContentLoaded', () => {
        setActiveFromHash();
    })

    sidebarUL.addEventListener('click', (event) => {
        const links = sidebarUL.querySelectorAll('li');
        links.forEach(link => {
            if (event.target == link.firstChild) {
                link.classList.add('active')
            } else {
                link.classList.remove('active')
            }
        })
    })
})

function setActiveFromHash(): void {
  // Get the current page's hash from the URL
  const hash = window.location.hash;
  
  // Check if there's a hash in the URL
  if (hash) {
    // Find the rate-links and rate-side elements
    const sidebarUL = document.querySelector('.rate-links');
    const rateSide = document.querySelector('.rate-side');
    
    if (sidebarUL) {
      // Look for an element with href matching the hash
      const targetLink = sidebarUL.querySelector(`a[href="${hash}"]`) as HTMLAnchorElement;
      
      if (targetLink && targetLink.parentElement) {
        // Add "active" to its parent element's classList
        targetLink.parentElement.classList.add('active');
      }
    }
    
    if (rateSide) {
      // Look for accordion element matching the hash
      // Use CSS.escape to handle special characters in selectors
      const escapedHash = CSS.escape(hash.substring(1)); // Remove # and escape
      const targetAccordion = rateSide.querySelector(`#${escapedHash}`);
      
      if (targetAccordion) {
        targetAccordion.classList.add('active')
        const content = targetAccordion.querySelector('.js-accordion-content') as HTMLDivElement;

        if (content) {
            content.style.display = "block";
        }

      }
    }
  }
}